export function isInterruptingInstruction(instruction) {
    return 'EstablishSyncStream' in instruction || 'CloseSyncStream' in instruction;
}
//# sourceMappingURL=core-instruction.js.map